var states = [
    {
        "label": "Louisiana",
        "val": "LA"
    },
    {
        "label": "Texas",
        "val": "TX"
    },
    {
        "label": "Alabama",
        "val": "AL"
    },
    {
        "label": "Alaska",
        "val": "AK"
    },
    {
        "label": "Arizona",
        "val": "AZ"
    },
    {
        "label": "Arkansas",
        "val": "AR"
    },
    {
        "label": "California",
        "val": "CA"
    },
    {
        "label": "Colorado",
        "val": "CO"
    },
    {
        "label": "Connecticut",
        "val": "CT"
    },
    {
        "label": "Delaware",
        "val": "DE"
    },
    {
        "label": "District Of Columbia",
        "val": "DC"
    },
    {
        "label": "Florida",
        "val": "FL"
    },
    {
        "label": "Georgia",
        "val": "GA"
    },
    {
        "label": "Guam Gu",
        "val": "GU"
    },
    {
        "label": "Hawaii",
        "val": "HI"
    },
    {
        "label": "Idaho",
        "val": "ID"
    },
    {
        "label": "Illinois",
        "val": "IL"
    },
    {
        "label": "Indiana",
        "val": "IN"
    },
    {
        "label": "Iowa",
        "val": "IA"
    },
    {
        "label": "Kansas",
        "val": "KS"
    },
    {
        "label": "Kentucky",
        "val": "KY"
    },
    
    {
        "label": "Maine",
        "val": "ME"
    },
    {
        "label": "Maryland",
        "val": "MD"
    },
    {
        "label": "Massachusetts",
        "val": "MA"
    },
    {
        "label": "Michigan",
        "val": "MI"
    },
    {
        "label": "Minnesota",
        "val": "MN"
    },
    {
        "label": "Mississippi",
        "val": "MS"
    },
    {
        "label": "Missouri",
        "val": "MO"
    },
    {
        "label": "Montana",
        "val": "MT"
    },
    {
        "label": "Nebraska",
        "val": "NE"
    },
    {
        "label": "Nevada",
        "val": "NV"
    },
    {
        "label": "New Hampshire",
        "val": "NH"
    },
    {
        "label": "New Jersey",
        "val": "NJ"
    },
    {
        "label": "New Mexico",
        "val": "NM"
    },
    {
        "label": "New York",
        "val": "NY"
    },
    {
        "label": "North Carolina",
        "val": "NC"
    },
    {
        "label": "North Dakota",
        "val": "ND"
    },
    {
        "label": "Ohio",
        "val": "OH"
    },
    {
        "label": "Oklahoma",
        "val": "OK"
    },
    {
        "label": "Oregon",
        "val": "OR"
    },
    {
        "label": "Pennsylvania",
        "val": "PA"
    },
    {
        "label": "Puerto Rico",
        "val": "PR"
    },
    {
        "label": "Rhode Island",
        "val": "RI"
    },
    {
        "label": "South Carolina",
        "val": "SC"
    },
    {
        "label": "South Dakota",
        "val": "SD"
    },
    {
        "label": "Tennessee",
        "val": "TN"
    },
    {
        "label": "Utah",
        "val": "UT"
    },
    {
        "label": "Vermont",
        "val": "VT"
    },
    {
        "label": "Virgin Islands",
        "val": "VI"
    },
    {
        "label": "Virginia",
        "val": "VA"
    },
    {
        "label": "Washington",
        "val": "WA"
    },
    {
        "label": "West Virginia",
        "val": "WV"
    },
    {
        "label": "Wisconsin",
        "val": "WI"
    },
    {
        "label": "Wyoming",
        "val": "WY"
    }
]

module.exports = states;